import { fetch } from '../request'

export interface IPublishParams {
  name: string
  message: string
  cover_oss_path: string
  preview_video_cut_info?: string
  copyright_limited: string
  generate_record_xihe_task_id: string
  custom_preview_video_path?: string
  tags?: any
}

// 用户发布成片复制接口
export const postPersonPublishTemplate = (params: IPublishParams) => {
  return fetch('/xihe_offline/generate_record_task/person_publish_template/', {
    method: 'POST',
    body: params,
  })
}
